import styled, { css } from 'styled-components';
import { readableColor as textColorContrast } from 'polished';
import { fontBody } from 'Styles/fonts';
import breakpoint from 'Styles/breakpoints';
import { convertColorToThemeHexCode } from 'Styles/colors.util';

export const Alertbar = styled.div`
  background-color: ${(props) => props.alertbarBackgroundColor};
  display: flex;
  z-index: 600;
  ${fontBody(14)}
  align-items: center;
  color: var(--background);
  padding: 8px 0;
  min-height: 48px;
  position: relative;

  ${(props) =>
    props.textAlignment === 'left'
      ? css`
          justify-content: flex-start;
        `
      : css`
          justify-content: center;
          text-align: center;
        `}

  & p,
  a {
    color: ${(props) =>
      textColorContrast(
        props.alertbarBackgroundColor,
        convertColorToThemeHexCode('white'),
        convertColorToThemeHexCode('black')
      )};
  }
`;

export const AlertbarBlock = styled.div`
  background-color: ${(props) => props.alertbarBackgroundColor};
  min-height: 48px;
`;

const AlertBarParagraph = styled.p`
  margin: 0;
  b {
    font-weight: bold;
  }

  a {
    text-decoration: none;
    color: var(--background);
  }
`;

export const AlertbarMobileParagraph = styled(AlertBarParagraph)`
  ${breakpoint('large')} {
    display: none;
  }
`;

export const AlertbarDesktopParagraph = styled(AlertBarParagraph)`
  display: none;
  ${breakpoint('large')} {
    display: block;
  }
`;

export const DesktopCountryPickerWrapper = styled.div`
  display: none;

  ${breakpoint('large')} {
    display: block;
    transform: translateY(-50%);
    position: absolute;
    right: 36px;
    top: 50%;
  }
`;

export default {};
